/**
 * Chuỗi của màn Dashboard RPA (`/rpa`) — namespace `rpa.dashboard`, `rpa.robotStatus` của web-portal native, đổi sang
 * kiểu dấu thanh mới. Tạm tách tệp, sẽ gộp vào `vi.ts`.
 */
export const viRpaTongQuan = {
  rpaTongQuan: {
    moTa: 'Lượt chạy Robot, tỷ lệ thành công và tình trạng Robot theo Project — đọc từ instance OpenRPA trên OpenCore.',
    xuatCsv: 'Xuất CSV',
    daXuat: 'Đã xuất dữ liệu Dashboard.',
    locProject: 'Lọc theo Project',
    moiProject: 'Tất cả Project',
    khoangNgay: 'Khoảng thời gian',
    soNgay: '{{so}} ngày gần nhất',
    thoiGianThuc: 'Tự làm mới mỗi 30 giây',
    khongLamMoiDuoc: 'Không làm mới được, đang hiện số liệu cũ',
    biCat: 'Đã đọc tới giới hạn {{so}} lượt chạy: số liệu có thể thiếu lượt cũ. Thu hẹp khoảng ngày hoặc chọn một Project.',
    kpiProject: 'Tổng số Project',
    kpiRobot: 'Robot đang chạy',
    kpiThanhCong: 'Số phiên thành công',
    kpiTyLe: 'Tỷ lệ {{tyLe}}%',
    kpiLoi: 'Số phiên lỗi',
    kpiTyLeLoi: 'Tỷ lệ lỗi {{tyLe}}%',
    theoNgay: 'Lượt chạy theo ngày',
    tong: 'Tổng',
    thanhCong: 'Thành công',
    loi: 'Lỗi',
    dangChay: 'Đang chạy',
    biDung: 'Bị dừng',
    moTaCot: 'Ngày {{ngay}}: {{so}} lượt chạy',
    soLuotThe: '{{so}} lượt',
    chuaCoDuLieu: 'Chưa có lượt chạy nào trong khoảng ngày này.',
    tyLeTieuDe: 'Tỷ lệ thành công / lỗi',
    thanhCongNgan: 'thành công',
    tyLeThanhCong: 'Tỷ lệ thành công',
    tyLeLoi: 'Tỷ lệ lỗi',
    tongPhien: 'Trên {{so}} phiên đã kết thúc trên OpenCore (không tính lượt bị dừng tay)',
    chuaCoLuotXong: 'Chưa có lượt chạy nào kết thúc trong khoảng ngày này.',
    theoProject: 'Lượt chạy theo Project',
    theoProjectGoiY: 'Thành công / Lỗi',
    okLoi: '{{ok}} / {{loi}}',
    moTaProject: '{{project}}: {{chiTiet}}',
    chuaCoProject: 'Chưa có lượt chạy nào theo Project.',
    chuaGanProject: 'Chưa gán Project',
    tinhTrangRobot: 'Tình trạng Robot',
    chuaCoRobot: 'Chưa có lượt chạy nào của Robot trên OpenCore trong khoảng ngày này.',
    robot: {
      running: 'Đang chạy',
      idle: 'Sẵn sàng',
      error: 'Lần chạy gần nhất lỗi',
      unknown: 'Chưa có dữ liệu vận hành',
    },
    danhSachLuot: 'Danh sách lượt Robot chạy',
    timLuot: 'Tìm Project / quy trình / máy / lỗi...',
    locTrangThai: 'Lọc theo trạng thái',
    moiTrangThai: 'Mọi trạng thái',
    chuaCoLuot: 'Chưa có lượt chạy nào',
    chuaCoLuotMoTa: 'Lượt chạy OpenRPA hiện ở đây sau khi Robot chạy Workflow trong khoảng ngày đã chọn.',
    rongLoc: 'Không có lượt chạy nào khớp bộ lọc',
    cotThoiGian: 'Thời gian',
    cotProject: 'Tên Project',
    cotWorkflow: 'Tên quy trình',
    cotThoiLuong: 'Thời gian thực hiện',
    cotTrangThai: 'Trạng thái',
    dangChayNhan: 'đang chạy...',
    thoiLuongGio: '{{gio}} giờ {{phut}} phút',
    thoiLuongPhut: '{{phut}} phút {{giay}} giây',
    thoiLuongGiay: '{{giay}} giây',
    xemChiTiet: 'Xem báo cáo lỗi',
    xemChiTietCua: 'Xem báo cáo lỗi của {{ten}}',
    tongTrang: '{{tu}}–{{den}} / {{tong}} lượt chạy',
    soLuotLoc: '{{so}} / {{tong}} lượt chạy khớp bộ lọc',
    chuThichLuot: 'Lượt chạy đọc từ OpenCore, tối đa 200 lượt mới nhất trong khoảng ngày đã chọn.',
    csv: {
      instanceId: 'Instance ID',
      batDau: 'Bắt đầu',
      ketThuc: 'Kết thúc',
      project: 'Project',
      workflow: 'Workflow',
      may: 'Máy',
      trangThai: 'Trạng thái',
      thoiLuongMs: 'Thời gian (ms)',
      loi: 'Lỗi',
    },
  },
} as const;
